import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CloseEventIcon = createIcon({
    viewBox: '18 14 73 73',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M76.121 63.464L74 65.586L71.879 63.464C71.7861 63.3711 71.6758 63.2974 71.5544 63.2471C71.433 63.1968 71.3029 63.1709 71.1715 63.1709C71.0401 63.1709 70.91 63.1968 70.7886 63.2471C70.6672 63.2974 70.5569 63.3711 70.464 63.464C70.3711 63.5569 70.2974 63.6672 70.2471 63.7886C70.1968 63.91 70.1709 64.0401 70.1709 64.1715C70.1709 64.3029 70.1968 64.433 70.2471 64.5544C70.2974 64.6758 70.3711 64.7861 70.464 64.879L72.586 67L70.464 69.121C70.2764 69.3086 70.1709 69.5631 70.1709 69.8285C70.1709 70.0939 70.2764 70.3484 70.464 70.536C70.6516 70.7236 70.9061 70.8291 71.1715 70.8291C71.4369 70.8291 71.6914 70.7236 71.879 70.536L74 68.414L76.121 70.536C76.2139 70.6289 76.3242 70.7026 76.4456 70.7529C76.567 70.8032 76.6971 70.8291 76.8285 70.8291C76.9599 70.8291 77.09 70.8032 77.2114 70.7529C77.3328 70.7026 77.4431 70.6289 77.536 70.536C77.6289 70.4431 77.7026 70.3328 77.7529 70.2114C77.8032 70.09 77.8291 69.9599 77.8291 69.8285C77.8291 69.6971 77.8032 69.567 77.7529 69.4456C77.7026 69.3242 77.6289 69.2139 77.536 69.121L75.414 67L77.536 64.879C77.7236 64.6914 77.8291 64.4369 77.8291 64.1715C77.8291 63.9061 77.7236 63.6516 77.536 63.464C77.3484 63.2764 77.0939 63.1709 76.8285 63.1709C76.5631 63.1709 76.3086 63.2764 76.121 63.464Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M74 76C70.47 76 67.41 73.96 65.939 71C65.623 70.3633 65.3817 69.6922 65.22 69C65.08 68.36 65 67.69 65 67C65 62.04 69.04 58 74 58C74.689 58 75.36 58.08 76 58.22C80 59.14 83 62.73 83 67C83 71.96 78.96 76 74 76ZM63.18 69H27C26.45 69 26 68.55 26 68V30C26 29.45 26.45 29 27 29H73C73.55 29 74 29.45 74 30V56C67.92 56 63 60.92 63 67C63 67.68 63.061 68.35 63.18 69ZM76 56.19V30C76 28.34 74.66 27 73 27H27C25.34 27 24 28.34 24 30V68C24 69.66 25.34 71 27 71H63.75C65.35 75.1 69.33 78 74 78C80.07 78 85 73.08 85 67C85 61.61 81.12 57.13 76 56.19Z'
                fill='currentColor'
            />
            <Path
                d='M64 51H37C36.4477 51 36 51.4477 36 52C36 52.5523 36.4477 53 37 53H64C64.5523 53 65 52.5523 65 52C65 51.4477 64.5523 51 64 51Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24 40H75V42H24V40Z'
                fill='currentColor'
            />
            <Path
                d='M54 58H37C36.4477 58 36 58.4477 36 59C36 59.5523 36.4477 60 37 60H54C54.5523 60 55 59.5523 55 59C55 58.4477 54.5523 58 54 58Z'
                fill='currentColor'
            />
            <Path
                d='M38 24C38 23.4477 37.5523 23 37 23C36.4477 23 36 23.4477 36 24V32C36 32.5523 36.4477 33 37 33C37.5523 33 38 32.5523 38 32V24Z'
                fill='currentColor'
            />
            <Path
                d='M64 24C64 23.4477 63.5523 23 63 23C62.4477 23 62 23.4477 62 24V32C62 32.5523 62.4477 33 63 33C63.5523 33 64 32.5523 64 32V24Z'
                fill='currentColor'
            />
        </>
    ),
})

CloseEventIcon.displayName = 'CloseEventIcon'
